import * as React from 'react';

interface PublicRouteProps {
  element: JSX.Element;
}

/**
 * PublicRoute - 누구나 접근 가능한 라우트
 * 로그인 여부와 관계없이 모든 사용자가 접근 가능
 */
const PublicRoute: React.FC<PublicRouteProps> = ({ element }) => {
  return element;
};

export default PublicRoute;






